import { useEffect } from "react";
import { useCookies } from "react-cookie";

/*
SP_DEEPLINK_AUTH_REDIRECT is need to be removed as its not getting used by FE and BE
and its getting created by za opco vodafone.com and breaking our getaccount call due to big json object in header
*/

const COOKIES_TO_REMOVE = ["SP_DEEPLINK_AUTH_REDIRECT"];

const useRemoveCookies = () => {
  const [, , removeCookies] = useCookies();
  console.log("Removing cookies:", COOKIES_TO_REMOVE);
  useEffect(() => {
    COOKIES_TO_REMOVE.forEach((cookieName) => {
      removeCookies(cookieName, { path: "/" });
    });
  }, [removeCookies]);
};

export default useRemoveCookies;
